<template>
  <ul class="menu-wrapper">
    <li :class="['menu-item', item.active ? 'active' : '']" v-for="item in items" v-if="!item.hide" @click="onChangeMenu(item)">{{item.name}}</li>
  </ul>
</template>

<script>
export default {
  name: 'Menu',
  props: {
    items: Array,
  },
  methods: {
    onChangeMenu: function (item) {
      if (!item.active) {
        this.$emit('on-change-menu', item.id)
      }
    },
  },
};
</script>

<style scoped lang="scss">
.menu-wrapper {
  position: relative;
  display: inline-flex;
  list-style: none;
  padding: 0 10px;
  margin: 0 10px 20px;

  &::after {
    content: '';
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    height: 2px;
    background-color: #f0f0f0;
  }

  .menu-item {
    position: relative;
    margin: 0 10px;
    font-size: 18px;
    line-height: 28px;
    cursor: pointer;

    &.active,
    &:hover {
      color: #e51c23;

      &::after {
        content: '';
        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
        height: 2px;
        background-color: #e51c23;
        z-index: 1;
      }
    }
  }
}
</style>
